import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { DrawAddressLink } from './components/DrawAddressLink';
import { ContinueDrawButton } from './components/ContinueDrawButton';

interface ContinueDrawCardProps {
    dashboardDrawBudget: IDashboardDrawBudget;
}

export const ContinueDrawCard: React.FC<ContinueDrawCardProps> = ({ dashboardDrawBudget }) => {
    return (
        <div className='row draw-continue-container'>
            <DrawAddressLink dashboardDrawBudget={dashboardDrawBudget} />
            <div className='draw-continue-button'>
                <ContinueDrawButton dashboardDrawBudget={dashboardDrawBudget} />
            </div>
        </div>
    );
};
